// 添加埋点事件
class CustomEventGa extends HTMLElement {
  constructor() {
    super();
    this.handleEvent = this.handleEvent.bind(this);
  }
  connectedCallback() {
    this.targetInit();
    this.userId = this.dataset.id || null;
    this.init();
  }
  // 目标元素进入可视区初始化
  targetInit() {
    const items = document.querySelectorAll('.target-show-item');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const parameters = {
            action: entry.target.getAttribute('data-action') || 'view',
            category: entry.target.getAttribute('data-category') || 'N/A',
            label: entry.target.getAttribute('data-label') || 'N/A',
            event: entry.target.getAttribute('data-event') || 'view_event',
          }
          this.passParam(parameters);
          // 只触发一次就取消监听
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.2
    });

    // 一次性监听所有节点
    items.forEach(item => observer.observe(item));

  }
  // 传参示例
  passParam(parameters) {
    dataLayer.push({
      event: parameters.event,
      page_type: parameters.category,
      event_label: parameters.label,
      event_action: parameters.action,
      page_path: window.location.href,
      page_title: document.title,
      page_referrer: document.referrer,
      device_type: this.getDeviceType(),
      session_id: new Date().getTime(),
      user_id: this.userId
    });
  }
  // 点击事件初始化
  init() {
    document.addEventListener('click', (event) => {
      var target = event.target;
      var eventHandlesEl = target.getAttribute('data-event');
      var parameters = target.dataset;
      if (!parameters) return;

      try {
        this.handleEvent(eventHandlesEl, eventHandlesEl, {
          ...parameters
        });
      } catch (error) {
        console.error(error);
      }
    });
  }
  getDeviceType() {
    const ua = navigator.userAgent;
    if (/Mobile|Android|iPhone|iPad|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua)) {
      return /iPad/.test(ua) ? 'tablet' : 'Mobile';
    }
    return 'PC';
  }
  handleEvent(el, event = 'click', parameters) {
    // console.log(parameters);
    
     this.passParam(parameters);

  }
}

if (!customElements.get('custom-event')) {
  customElements.define('custom-event', CustomEventGa);
}



